import { useCallback, useEffect, useMemo, useState } from 'react';
import { CommonProperties } from '../../common/common.interfaces';
import CustomError, { CustomErrorProps } from '../../common/components/CustomError';
import { useLoading } from '../../loading/LoadingContext';
import { useUserContext } from '../../user/UserContext';
import UniversalConstructorImportControls from './UCImportControls';
import { Container } from 'react-bootstrap';
import { MapperConfigurationRelation, MapperConfigurationSet, RawRow, UniversalConstructorContainer } from '../universalConstructor.interfaces';
import UniversalConstructorImportTable from './UCImportTable';
import buildOrders from '../mappers/universal.mapper';
import { AzureTableRowKeys } from '../../common/common.table.interfaces';
import { apiFetch } from '../../utility/fetch';


interface UniversalConstructorImportProps extends CommonProperties {}
export default function UniversalConstructorImport (props : UniversalConstructorImportProps){
  
  const [importError, setImportError]: [CustomErrorProps, any] = useState(undefined)
  const [rawRows, setRawRows]: [RawRow[], any] = useState(undefined)
  const [mapperConfigSet, setMapperConfigSet]: [MapperConfigurationSet, any] = useState(undefined)
  const [orderContainer, setOrderContainer]: [UniversalConstructorContainer, any]= useState<UniversalConstructorContainer>(undefined)
  const {toggleLoading, changeStep, changeSubStep} = useLoading()
  const {userData} = useUserContext()

  const processRows = useCallback((rawRows: RawRow[], mapperConfigSet: MapperConfigurationSet) => {
    console.log(rawRows)
    setRawRows(rawRows)
    setMapperConfigSet(mapperConfigSet)
  }, []);

  const getGenericAzureTable = useCallback(async (table: string) => {

    const response = await apiFetch<AzureTableRowKeys[]>({
      endpoint: 'azureTables',
      method: 'GET',
      accessToken: userData.accessToken,
      params: [
        {key: 'table', value: table},
      ]
    })

    if (!response.body || response.body.length < 1) {
      throw new Error(`Couldn't fetch ${table} Table`)
    }

    return response.body

  }, [])


  // #region BUILD ORDERS
  const constructMissionControlEntities = useCallback(async () => {


    const countryCodesSet = await getGenericAzureTable('countryCodes')
    const stateCodesSet = await getGenericAzureTable('stateCodes')

    let orderContainer = undefined
    try {
      orderContainer = await buildOrders({rawRows, mapperConfigSet, countryCodesSet, stateCodesSet, userData})
    }catch(error){
      if(error)
      setImportError({
        content: JSON.stringify(error),
        description: `Couldn't map Order Number. Did you select the correct Account?`,
        title: 'Import Preview Failed',
        visible: true
      } as CustomErrorProps)
      toggleLoading(false)
      return
    }

    setOrderContainer(orderContainer)
    toggleLoading(false)
  }, [mapperConfigSet, rawRows, userData])

  const clearOrders = useCallback(() => {
    setOrderContainer()
    setRawRows()
    setImportError({
      visible: false
    })
  }, [])
 
  const updateOrders = useEffect(() => {
    // ignore if not ready
    if (!mapperConfigSet || !rawRows) {
      return
    }
    constructMissionControlEntities()
  }, [mapperConfigSet, rawRows])

  const handleCloseImportError = useCallback((e) => {
    setImportError({
      visible: false
    })
  }, [])

  // #region VIEW
  const view = useMemo(() => {
    
    return (
      <div>
        <UniversalConstructorImportControls 
          dataImport={processRows}
          finishOrdersUpload={clearOrders}
          container={orderContainer}
        />

        {/* Main Window */}
        <div className='d-flex flex-wrap flex-row'>
          
          {/* MC Window */}
          <Container>
            <UniversalConstructorImportTable
              container={orderContainer}
              mapperConfigurationSet={mapperConfigSet}
            />
          </Container>
        </div>
        
        <CustomError closeError={handleCloseImportError} content={importError?.content} description={importError?.description} title={importError?.title} visible={importError?.visible} />
      </div>
    )
  }, [importError, rawRows, orderContainer, mapperConfigSet])

  return view
}